import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const TikTokOverviewGate = React.lazy(() => import("./TikTokOverview.gate"));

const TikTokOverviewLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <TikTokOverviewGate />
  </React.Suspense>
);

export default () => <TikTokOverviewLoadable />;
